export const Area = {
  BOTTOM: 'bottom',
  DEFAULT: 'default',
  LEFT: 'left',
  RIGHT: 'right',
  TOP: 'top'
};

export default Area;
